import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=e5fdc696&scoped=true&"
import script from "./CustomModal.vue?vue&type=script&lang=js&"
export * from "./CustomModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=e5fdc696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fdc696",
  null
  
)

export default component.exports